/**
 * Agent Prompt Pattern Library — external research provenance.
 *
 * The upstream repository is a REFERENCE-ONLY, UNTRUSTED, NON-AUTHORITATIVE
 * research corpus. Smart Shikka makes NO runtime dependency on it, vendors no
 * files from it, and copies no prompt bodies. Provenance entries record only
 * which sources inspired which abstracted Shikka-native patterns.
 */
export const AGENT_PROMPT_REFERENCE_SOURCE = {
    repository: "https://github.com/asgeirtj/system_prompts_leaks",
    commit: "c7b2c31df51e64784603f5740a251b445fd88c46",
    reviewedAt: "2026-09-19",
    posture: "reference-only untrusted research corpus; no runtime dependency; " +
        "no verbatim prompt bodies copied into Smart Shikka",
};
//# sourceMappingURL=provenance.js.map